import { _getSavingsCorpus } from "./sip-calculator";

// the required SIP is rounded up to this amount, so the user gets a practical figure
const SIP_ROUNDING_STEP = 500;

// corpus needed at retirement = the yearly expenses of the retirement year x corpus_multiplier
// the monthly expenses (today's value) are grown by the inflation rate (in %) till the retirement age
export const _getRetirementCorpus = (params) => {
    const years_to_retirement = Number(params.retirement_age) - Number(params.current_age);

    if (years_to_retirement <= 0) {
        return 0;
    }

    const inflation_rate = (Number(params.inflation_rate) || 0) / 100;
    const corpus_multiplier = Number(params.corpus_multiplier) || 0;

    const monthly_expenses_at_retirement = (Number(params.monthly_expenses) || 0) * Math.pow(1 + inflation_rate, years_to_retirement);

    return Math.round(monthly_expenses_at_retirement * 12 * corpus_multiplier);
};

// future value of ₹1 invested at the start of every month, with the SIP growing by step_up_rate % each year
// the monthly return is the annual return / 12, step_up_rate 0 is a flat SIP
const _getRetirementSipFactor = (annual_return, years, step_up_rate) => {
    const monthly_rate = (Number(annual_return) || 0) / 100 / 12;
    const yearly_step_up = 1 + (Number(step_up_rate) || 0) / 100;

    // 12 monthly investments of ₹1, grown to the end of that year
    let year_factor = 12;
    if (monthly_rate !== 0) {
        year_factor = ((Math.pow(1 + monthly_rate, 12) - 1) / monthly_rate) * (1 + monthly_rate);
    }

    let factor = 0;
    for (let year = 0; year < years; year++) {
        const months_left = (years - year - 1) * 12;
        factor += Math.pow(yearly_step_up, year) * year_factor * Math.pow(1 + monthly_rate, months_left);
    }
    return factor;
};

// corpus the monthly SIP grows to in the given years
export const _getRetirementSipCorpus = (monthly_sip, annual_return, years, step_up_rate) => {
    return Math.round((Number(monthly_sip) || 0) * _getRetirementSipFactor(annual_return, years, step_up_rate));
};

// monthly SIP (the first year SIP when stepping up) needed to reach the target corpus along with the current savings
export const _getRetirementRequiredSip = (target_corpus, current_savings, annual_return, years, step_up_rate) => {
    const factor = _getRetirementSipFactor(annual_return, years, step_up_rate);
    if (factor === 0) {
        return 0;
    }

    const corpus_needed_from_sip = Math.max(0, target_corpus - _getSavingsCorpus(current_savings, annual_return, years));
    return Math.ceil(corpus_needed_from_sip / factor / SIP_ROUNDING_STEP) * SIP_ROUNDING_STEP;
};
